import Index from '@/views/admin/admin/Index.vue';

import Setting from '@/views/admin/admin/Setting.vue';
// import Cleansing from '@/views/admin/admin/Cleansing.vue';
import Cleansing from '@/views/admin/admin/Cleansing2.vue';

import AnalysisFavoriteIndex from '@/views/admin/admin/analysis/favorite/Index.vue';
import AnalysisFavoriteDetail from '@/views/admin/admin/analysis/favorite/Detail.vue';
import AnalysisUUIndex from '@/views/admin/admin/analysis/uu/Index.vue';
import AnalysisUUDetail from '@/views/admin/admin/analysis/uu/Detail.vue';

import AnalysisContactIndex from '@/views/admin/admin/analysis/contact/Index.vue';
import AnalysisContactDetail from '@/views/admin/admin/analysis/contact/Detail.vue';

import AnalysisVisIndex from '@/views/admin/admin/analysis/vis/Index.vue';
import AnalysisVisDetail from '@/views/admin/admin/analysis/vis/Detail.vue';

import BuyerIndex from '@/views/admin/admin/buyer/Index.vue';
import BuyerDetail from '@/views/admin/admin/buyer/Detail.vue';
import BuyerEdit from '@/views/admin/admin/buyer/Edit.vue';
import BuyerModify from '@/views/admin/admin/buyer/Modify.vue';

import ExhibitorIndex from '@/views/admin/admin/exhibitor/Index.vue';
import ExhibitorDetail from '@/views/admin/admin/exhibitor/Detail.vue';
import ExhibitorModify from '@/views/admin/admin/exhibitor/Modify.vue';

import ExhibitionIndex from '@/views/admin/admin/exhibition/Index.vue';
import ExhibitionDetail from '@/views/admin/admin/exhibition/Detail.vue';
import ExhibitionModify from '@/views/admin/admin/exhibition/Modify.vue';

import BrandIndex from '@/views/admin/admin/brand/Index.vue';
// import BrandDetail from '@/views/admin/admin/brand/Detail.vue';
import BrandEdit from '@/views/admin/admin/brand/Edit.vue';
import BrandNew from '@/views/admin/admin/brand/New.vue';

import BoothIndex from '@/views/admin/admin/booth/Index.vue';
// import BoothDetail from '@/views/admin/admin/booth/Detail.vue';
import BoothNew from '@/views/admin/admin/booth/New.vue';
import BoothEdit from '@/views/admin/admin/booth/Edit.vue';
// import BoothPrview from '@/views/admin/admin/booth/Preview.vue';

import ItemIndex from '@/views/admin/admin/item/Index.vue';
// import ItemDetail from '@/views/admin/admin/item/Detail.vue';
import ItemEdit from '@/views/admin/admin/item/Edit.vue';
import ItemNew from '@/views/admin/admin/item/New.vue';

import AccountSetting from '@/views/admin/admin/account/Setting.vue';

import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'admin',
    component: Index,
    children: [
      {
        name: 'admin-admin-account-setting',
        path: 'account/setting',
        component: AccountSetting,
        meta: {
          title: 'admin-admin-account-setting',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-cleasing',
        path: 'cleasing',
        component: Cleansing,
        meta: {
          title: 'admin-admini-cleasing',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-setting',
        path: 'setting',
        component: Setting,
        meta: {
          title: 'admin-admini-setting',
          actor: actors.none,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibition-index',
        path: 'exhibitions',
        component: ExhibitionIndex,
        meta: {
          title: 'admin-admin-exhibition-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibition-detail',
        path: 'exhibitions/:id',
        component: ExhibitionDetail,
        meta: {
          title: 'admin-admin-exhibition-detail',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibition-modify',
        path: 'exhibitions/modify/:id',
        component: ExhibitionModify,
        meta: {
          title: 'admin-admin-exhibition-modify',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibitor-index',
        path: 'exhibitors',
        component: ExhibitorIndex,
        meta: {
          title: 'admin-admin-exhibitor-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibitor-modify',
        path: 'exhibitors/modify',
        component: ExhibitorModify,
        meta: {
          title: 'admin-admin-exhibitor-modify',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-exhibitor-detail',
        path: 'exhibitors/:id',
        component: ExhibitorDetail,
        meta: {
          title: 'admin-admin-exhibitor-detail',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-buyer-index',
        path: 'buyers',
        component: BuyerIndex,
        meta: {
          title: 'admin-admin-buyer-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-buyer-detail',
        path: 'buyers/:id',
        component: BuyerDetail,
        meta: {
          title: 'admin-admin-buyer-detail',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-buyer-edit',
        path: 'buyers/edit',
        component: BuyerEdit,
        meta: {
          title: 'admin-admin-buyer-edit',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-buyer-modify',
        path: 'buyers/modify/:id',
        component: BuyerModify,
        meta: {
          title: 'admin-admin-buyer-modify',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-brand-index',
        path: 'brand',
        component: BrandIndex,
        meta: {
          title: 'admin-admin-brand-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      // {
      //   name: 'admin-admin-brand-detail',
      //   path: 'brand/:id',
      //   component: BrandDetail,
      //   meta: {
      //     title: 'admin-admin-brand-detail',
      //     actor: actors.admin,
      //     auth: auths.required,
      //   },
      // },
      {
        name: 'admin-admin-brand-new',
        path: 'brand/new',
        component: BrandNew,
        meta: {
          title: 'admin-admin-brand-new',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-brand-edit',
        path: 'brand/edit',
        component: BrandEdit,
        meta: {
          title: 'admin-admin-brand-edit',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-booth-index',
        path: 'booth',
        component: BoothIndex,
        meta: {
          title: 'admin-admin-booth-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      // {
      //   name: 'admin-admin-booth-detail',
      //   path: 'booth/:id',
      //   component: BoothDetail,
      //   meta: {
      //     title: 'admin-admin-booth-detail',
      //     actor: actors.admin,
      //     auth: auths.required,
      //   },
      // },
      {
        name: 'admin-admin-booth-new',
        path: 'booth/new',
        component: BoothNew,
        meta: {
          title: 'admin-admin-booth-new',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-booth-edit',
        path: 'booth/edit',
        component: BoothEdit,
        meta: {
          title: 'admin-admin-booth-edit',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      // {
      //   name: 'admin-admin-booth-prview',
      //   path: 'booth/preview',
      //   component: BoothPrview,
      //   meta: {
      //     title: 'admin-admin-booth-preview',
      //     actor: actors.admin,
      //     auth: auths.required,
      //   },
      // },
      {
        name: 'admin-admin-item-index',
        path: 'item',
        component: ItemIndex,
        meta: {
          title: 'admin-admin-item-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      // {
      //   name: 'admin-admin-item-detail',
      //   path: 'item/:id',
      //   component: ItemDetail,
      //   meta: {
      //     title: 'admin-admin-item-detail',
      //     actor: actors.admin,
      //     auth: auths.required,
      //   },
      // },
      {
        name: 'admin-admin-item-new',
        path: 'item/new',
        component: ItemNew,
        meta: {
          title: 'admin-admin-item-new',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-item-edit',
        path: 'item/edit',
        component: ItemEdit,
        meta: {
          title: 'admin-admin-item-edit',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-favorite-index',
        path: 'analysis/favorites',
        component: AnalysisFavoriteIndex,
        meta: {
          title: 'admin-admin-analysis-favorite',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-favorite-detail',
        path: 'analysis/favorites/:id',
        component: AnalysisFavoriteDetail,
        meta: {
          title: 'admin-admin-analysis-favorite',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-uu-index',
        path: 'analysis/uu',
        component: AnalysisUUIndex,
        meta: {
          title: 'admin-admin-analysis-uu',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-uu-detail',
        path: 'analysis/uu/:id',
        component: AnalysisUUDetail,
        meta: {
          title: 'admin-admin-analysis-uu',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-contact-index',
        path: 'analysis/contacts',
        component: AnalysisContactIndex,
        meta: {
          title: 'admin-admin-analysis-contact-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-contact-detail',
        path: 'analysis/contacts/:id',
        component: AnalysisContactDetail,
        meta: {
          title: 'admin-admin-analysis-contact-detail',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-vis-index',
        path: 'analysis/vises',
        component: AnalysisVisIndex,
        meta: {
          title: 'admin-admin-analysis-vis-index',
          actor: actors.admin,
          auth: auths.required,
        },
      },
      {
        name: 'admin-admin-analysis-vis-detail',
        path: 'analysis/vises/:id',
        component: AnalysisVisDetail,
        meta: {
          title: 'admin-admin-analysis-vis-detail',
          actor: actors.admin,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
